/** Structural subset of a React keyboard event — keeps the helper pure and testable. */
export interface ActivationKeyEvent {
  key: string;
  preventDefault: () => void;
}

/**
 * Keyboard activation for row "buttons": Enter and Space trigger the action.
 * Space also prevents the default page scroll.
 */
export const createActivationKeyHandler =
  (onActivate: () => void) =>
  (event: ActivationKeyEvent): void => {
    if (event.key === "Enter") {
      onActivate();
      return;
    }
    if (event.key === " ") {
      event.preventDefault();
      onActivate();
    }
  };
